import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { autoChecklistService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type useMatchReRunMutationProps = {
	id: number;
	onSuccessHandler?: Function;
};

const useMatchReRunMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({ id }: useMatchReRunMutationProps) =>
			autoChecklistService.reRunMatch(id),
		{
			onSuccess(_, { onSuccessHandler }) {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Match re-run was successful",
					}),
				);
				onSuccessHandler?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useMatchReRunMutation;
